/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as Admin_chatRouteImport } from './routes/_admin_chat'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUpcomingRouteImport } from './routes/_authenticated/upcoming'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedReferralsRouteImport } from './routes/_authenticated/referrals'
import { Route as AuthenticatedMentorDataDashboardRouteImport } from './routes/_authenticated/mentor-data-dashboard'
import { Route as AuthenticatedExportsRouteImport } from './routes/_authenticated/exports'
import { Route as AuthenticatedAvaRouteImport } from './routes/_authenticated/ava'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthenticatedWordCloudIndexRouteImport } from './routes/_authenticated/word-cloud/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedSmsLifecycleIndexRouteImport } from './routes/_authenticated/sms-lifecycle/index'
import { Route as AuthenticatedRolesIndexRouteImport } from './routes/_authenticated/roles/index'
import { Route as AuthenticatedRiskFlaggingIndexRouteImport } from './routes/_authenticated/risk-flagging/index'
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index'
import { Route as AuthenticatedNewTeensIndexRouteImport } from './routes/_authenticated/new-teens/index'
import { Route as AuthenticatedMentorsIndexRouteImport } from './routes/_authenticated/mentors/index'
import { Route as AuthenticatedMentorScoringIndexRouteImport } from './routes/_authenticated/mentor-scoring/index'
import { Route as AuthenticatedMentorPayoutIndexRouteImport } from './routes/_authenticated/mentor-payout/index'
import { Route as AuthenticatedMentorForecastingIndexRouteImport } from './routes/_authenticated/mentor-forecasting/index'
import { Route as AuthenticatedKnowledgeBaseIndexRouteImport } from './routes/_authenticated/knowledge-base/index'
import { Route as AuthenticatedEscalationsIndexRouteImport } from './routes/_authenticated/escalations/index'
import { Route as AuthenticatedConversationsIndexRouteImport } from './routes/_authenticated/conversations/index'
import { Route as AuthenticatedChangelogIndexRouteImport } from './routes/_authenticated/changelog/index'
import { Route as AuthenticatedCampaignCodesIndexRouteImport } from './routes/_authenticated/campaign-codes/index'
import { Route as AuthenticatedAvaIndexRouteImport } from './routes/_authenticated/ava/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedRolesRoleIdRouteImport } from './routes/_authenticated/roles/$roleId'
import { Route as AuthenticatedMentorshipsMentorshipIdRouteImport } from './routes/_authenticated/mentorships/$mentorshipId'
import { Route as AuthenticatedMentorsSchedulesRouteImport } from './routes/_authenticated/mentors/schedules'
import { Route as AuthenticatedMentorScoringMentorIdRouteImport } from './routes/_authenticated/mentor-scoring/$mentorId'
import { Route as AuthenticatedMentorMonthlyUpdatesMentorshipIdRouteImport } from './routes/_authenticated/mentor-monthly-updates/$mentorshipId'
import { Route as AuthenticatedKnowledgeBaseNewRouteImport } from './routes/_authenticated/knowledge-base/new'
import { Route as AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRouteImport } from './routes/_authenticated/knowledge-base/$triggerKnowledgeBaseId'
import { Route as AuthenticatedCampaignCodesCodeIdRouteImport } from './routes/_authenticated/campaign-codes/$codeId'
import { Route as AuthenticatedCallsRoomIdRouteImport } from './routes/_authenticated/calls/$roomId'
import { Route as AuthenticatedAvaChatIdRouteImport } from './routes/_authenticated/ava/$chatId'
import { Route as Admin_chatChatMentorshipIdRouteImport } from './routes/_admin_chat/chat/$mentorshipId'
import { Route as AuthenticatedMentorScoringDetailsSnapshotIdRouteImport } from './routes/_authenticated/mentor-scoring/details/$snapshotId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const Admin_chatRoute = Admin_chatRouteImport.update({
  id: '/_admin_chat',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUpcomingRoute = AuthenticatedUpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReferralsRoute = AuthenticatedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMentorDataDashboardRoute =
  AuthenticatedMentorDataDashboardRouteImport.update({
    id: '/mentor-data-dashboard',
    path: '/mentor-data-dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExportsRoute = AuthenticatedExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAvaRoute = AuthenticatedAvaRouteImport.update({
  id: '/ava',
  path: '/ava',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedWordCloudIndexRoute =
  AuthenticatedWordCloudIndexRouteImport.update({
    id: '/word-cloud/',
    path: '/word-cloud/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSmsLifecycleIndexRoute =
  AuthenticatedSmsLifecycleIndexRouteImport.update({
    id: '/sms-lifecycle/',
    path: '/sms-lifecycle/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesIndexRoute = AuthenticatedRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRiskFlaggingIndexRoute =
  AuthenticatedRiskFlaggingIndexRouteImport.update({
    id: '/risk-flagging/',
    path: '/risk-flagging/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/onboarding/',
    path: '/onboarding/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNewTeensIndexRoute =
  AuthenticatedNewTeensIndexRouteImport.update({
    id: '/new-teens/',
    path: '/new-teens/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorsIndexRoute =
  AuthenticatedMentorsIndexRouteImport.update({
    id: '/mentors/',
    path: '/mentors/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorScoringIndexRoute =
  AuthenticatedMentorScoringIndexRouteImport.update({
    id: '/mentor-scoring/',
    path: '/mentor-scoring/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorPayoutIndexRoute =
  AuthenticatedMentorPayoutIndexRouteImport.update({
    id: '/mentor-payout/',
    path: '/mentor-payout/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorForecastingIndexRoute =
  AuthenticatedMentorForecastingIndexRouteImport.update({
    id: '/mentor-forecasting/',
    path: '/mentor-forecasting/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseIndexRoute =
  AuthenticatedKnowledgeBaseIndexRouteImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEscalationsIndexRoute =
  AuthenticatedEscalationsIndexRouteImport.update({
    id: '/escalations/',
    path: '/escalations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConversationsIndexRoute =
  AuthenticatedConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChangelogIndexRoute =
  AuthenticatedChangelogIndexRouteImport.update({
    id: '/changelog/',
    path: '/changelog/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignCodesIndexRoute =
  AuthenticatedCampaignCodesIndexRouteImport.update({
    id: '/campaign-codes/',
    path: '/campaign-codes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAvaIndexRoute = AuthenticatedAvaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAvaRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRolesRoleIdRoute =
  AuthenticatedRolesRoleIdRouteImport.update({
    id: '/roles/$roleId',
    path: '/roles/$roleId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorshipsMentorshipIdRoute =
  AuthenticatedMentorshipsMentorshipIdRouteImport.update({
    id: '/mentorships/$mentorshipId',
    path: '/mentorships/$mentorshipId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorsSchedulesRoute =
  AuthenticatedMentorsSchedulesRouteImport.update({
    id: '/mentors/schedules',
    path: '/mentors/schedules',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorScoringMentorIdRoute =
  AuthenticatedMentorScoringMentorIdRouteImport.update({
    id: '/mentor-scoring/$mentorId',
    path: '/mentor-scoring/$mentorId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute =
  AuthenticatedMentorMonthlyUpdatesMentorshipIdRouteImport.update({
    id: '/mentor-monthly-updates/$mentorshipId',
    path: '/mentor-monthly-updates/$mentorshipId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseNewRoute =
  AuthenticatedKnowledgeBaseNewRouteImport.update({
    id: '/knowledge-base/new',
    path: '/knowledge-base/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute =
  AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRouteImport.update({
    id: '/knowledge-base/$triggerKnowledgeBaseId',
    path: '/knowledge-base/$triggerKnowledgeBaseId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignCodesCodeIdRoute =
  AuthenticatedCampaignCodesCodeIdRouteImport.update({
    id: '/campaign-codes/$codeId',
    path: '/campaign-codes/$codeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCallsRoomIdRoute =
  AuthenticatedCallsRoomIdRouteImport.update({
    id: '/calls/$roomId',
    path: '/calls/$roomId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAvaChatIdRoute = AuthenticatedAvaChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => AuthenticatedAvaRoute,
} as any)
const Admin_chatChatMentorshipIdRoute =
  Admin_chatChatMentorshipIdRouteImport.update({
    id: '/chat/$mentorshipId',
    path: '/chat/$mentorshipId',
    getParentRoute: () => Admin_chatRoute,
  } as any)
const AuthenticatedMentorScoringDetailsSnapshotIdRoute =
  AuthenticatedMentorScoringDetailsSnapshotIdRouteImport.update({
    id: '/mentor-scoring/details/$snapshotId',
    path: '/mentor-scoring/details/$snapshotId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/ava': typeof AuthenticatedAvaRouteWithChildren
  '/exports': typeof AuthenticatedExportsRoute
  '/mentor-data-dashboard': typeof AuthenticatedMentorDataDashboardRoute
  '/referrals': typeof AuthenticatedReferralsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upcoming': typeof AuthenticatedUpcomingRoute
  '/chat/$mentorshipId': typeof Admin_chatChatMentorshipIdRoute
  '/ava/$chatId': typeof AuthenticatedAvaChatIdRoute
  '/calls/$roomId': typeof AuthenticatedCallsRoomIdRoute
  '/campaign-codes/$codeId': typeof AuthenticatedCampaignCodesCodeIdRoute
  '/knowledge-base/$triggerKnowledgeBaseId': typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  '/knowledge-base/new': typeof AuthenticatedKnowledgeBaseNewRoute
  '/mentor-monthly-updates/$mentorshipId': typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  '/mentor-scoring/$mentorId': typeof AuthenticatedMentorScoringMentorIdRoute
  '/mentors/schedules': typeof AuthenticatedMentorsSchedulesRoute
  '/mentorships/$mentorshipId': typeof AuthenticatedMentorshipsMentorshipIdRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/ava/': typeof AuthenticatedAvaIndexRoute
  '/campaign-codes/': typeof AuthenticatedCampaignCodesIndexRoute
  '/changelog/': typeof AuthenticatedChangelogIndexRoute
  '/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/escalations/': typeof AuthenticatedEscalationsIndexRoute
  '/knowledge-base/': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/mentor-forecasting/': typeof AuthenticatedMentorForecastingIndexRoute
  '/mentor-payout/': typeof AuthenticatedMentorPayoutIndexRoute
  '/mentor-scoring/': typeof AuthenticatedMentorScoringIndexRoute
  '/mentors/': typeof AuthenticatedMentorsIndexRoute
  '/new-teens/': typeof AuthenticatedNewTeensIndexRoute
  '/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/risk-flagging/': typeof AuthenticatedRiskFlaggingIndexRoute
  '/roles/': typeof AuthenticatedRolesIndexRoute
  '/sms-lifecycle/': typeof AuthenticatedSmsLifecycleIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/word-cloud/': typeof AuthenticatedWordCloudIndexRoute
  '/mentor-scoring/details/$snapshotId': typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/exports': typeof AuthenticatedExportsRoute
  '/mentor-data-dashboard': typeof AuthenticatedMentorDataDashboardRoute
  '/referrals': typeof AuthenticatedReferralsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/upcoming': typeof AuthenticatedUpcomingRoute
  '/chat/$mentorshipId': typeof Admin_chatChatMentorshipIdRoute
  '/ava/$chatId': typeof AuthenticatedAvaChatIdRoute
  '/calls/$roomId': typeof AuthenticatedCallsRoomIdRoute
  '/campaign-codes/$codeId': typeof AuthenticatedCampaignCodesCodeIdRoute
  '/knowledge-base/$triggerKnowledgeBaseId': typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  '/knowledge-base/new': typeof AuthenticatedKnowledgeBaseNewRoute
  '/mentor-monthly-updates/$mentorshipId': typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  '/mentor-scoring/$mentorId': typeof AuthenticatedMentorScoringMentorIdRoute
  '/mentors/schedules': typeof AuthenticatedMentorsSchedulesRoute
  '/mentorships/$mentorshipId': typeof AuthenticatedMentorshipsMentorshipIdRoute
  '/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/ava': typeof AuthenticatedAvaIndexRoute
  '/campaign-codes': typeof AuthenticatedCampaignCodesIndexRoute
  '/changelog': typeof AuthenticatedChangelogIndexRoute
  '/conversations': typeof AuthenticatedConversationsIndexRoute
  '/escalations': typeof AuthenticatedEscalationsIndexRoute
  '/knowledge-base': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/mentor-forecasting': typeof AuthenticatedMentorForecastingIndexRoute
  '/mentor-payout': typeof AuthenticatedMentorPayoutIndexRoute
  '/mentor-scoring': typeof AuthenticatedMentorScoringIndexRoute
  '/mentors': typeof AuthenticatedMentorsIndexRoute
  '/new-teens': typeof AuthenticatedNewTeensIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/risk-flagging': typeof AuthenticatedRiskFlaggingIndexRoute
  '/roles': typeof AuthenticatedRolesIndexRoute
  '/sms-lifecycle': typeof AuthenticatedSmsLifecycleIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/word-cloud': typeof AuthenticatedWordCloudIndexRoute
  '/mentor-scoring/details/$snapshotId': typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin_chat': typeof Admin_chatRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_authenticated/ava': typeof AuthenticatedAvaRouteWithChildren
  '/_authenticated/exports': typeof AuthenticatedExportsRoute
  '/_authenticated/mentor-data-dashboard': typeof AuthenticatedMentorDataDashboardRoute
  '/_authenticated/referrals': typeof AuthenticatedReferralsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/upcoming': typeof AuthenticatedUpcomingRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_admin_chat/chat/$mentorshipId': typeof Admin_chatChatMentorshipIdRoute
  '/_authenticated/ava/$chatId': typeof AuthenticatedAvaChatIdRoute
  '/_authenticated/calls/$roomId': typeof AuthenticatedCallsRoomIdRoute
  '/_authenticated/campaign-codes/$codeId': typeof AuthenticatedCampaignCodesCodeIdRoute
  '/_authenticated/knowledge-base/$triggerKnowledgeBaseId': typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  '/_authenticated/knowledge-base/new': typeof AuthenticatedKnowledgeBaseNewRoute
  '/_authenticated/mentor-monthly-updates/$mentorshipId': typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  '/_authenticated/mentor-scoring/$mentorId': typeof AuthenticatedMentorScoringMentorIdRoute
  '/_authenticated/mentors/schedules': typeof AuthenticatedMentorsSchedulesRoute
  '/_authenticated/mentorships/$mentorshipId': typeof AuthenticatedMentorshipsMentorshipIdRoute
  '/_authenticated/roles/$roleId': typeof AuthenticatedRolesRoleIdRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/ava/': typeof AuthenticatedAvaIndexRoute
  '/_authenticated/campaign-codes/': typeof AuthenticatedCampaignCodesIndexRoute
  '/_authenticated/changelog/': typeof AuthenticatedChangelogIndexRoute
  '/_authenticated/conversations/': typeof AuthenticatedConversationsIndexRoute
  '/_authenticated/escalations/': typeof AuthenticatedEscalationsIndexRoute
  '/_authenticated/knowledge-base/': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/_authenticated/mentor-forecasting/': typeof AuthenticatedMentorForecastingIndexRoute
  '/_authenticated/mentor-payout/': typeof AuthenticatedMentorPayoutIndexRoute
  '/_authenticated/mentor-scoring/': typeof AuthenticatedMentorScoringIndexRoute
  '/_authenticated/mentors/': typeof AuthenticatedMentorsIndexRoute
  '/_authenticated/new-teens/': typeof AuthenticatedNewTeensIndexRoute
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/_authenticated/risk-flagging/': typeof AuthenticatedRiskFlaggingIndexRoute
  '/_authenticated/roles/': typeof AuthenticatedRolesIndexRoute
  '/_authenticated/sms-lifecycle/': typeof AuthenticatedSmsLifecycleIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/word-cloud/': typeof AuthenticatedWordCloudIndexRoute
  '/_authenticated/mentor-scoring/details/$snapshotId': typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/ava'
    | '/exports'
    | '/mentor-data-dashboard'
    | '/referrals'
    | '/settings'
    | '/upcoming'
    | '/chat/$mentorshipId'
    | '/ava/$chatId'
    | '/calls/$roomId'
    | '/campaign-codes/$codeId'
    | '/knowledge-base/$triggerKnowledgeBaseId'
    | '/knowledge-base/new'
    | '/mentor-monthly-updates/$mentorshipId'
    | '/mentor-scoring/$mentorId'
    | '/mentors/schedules'
    | '/mentorships/$mentorshipId'
    | '/roles/$roleId'
    | '/users/$userId'
    | '/ava/'
    | '/campaign-codes/'
    | '/changelog/'
    | '/conversations/'
    | '/escalations/'
    | '/knowledge-base/'
    | '/mentor-forecasting/'
    | '/mentor-payout/'
    | '/mentor-scoring/'
    | '/mentors/'
    | '/new-teens/'
    | '/onboarding/'
    | '/risk-flagging/'
    | '/roles/'
    | '/sms-lifecycle/'
    | '/users/'
    | '/word-cloud/'
    | '/mentor-scoring/details/$snapshotId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/exports'
    | '/mentor-data-dashboard'
    | '/referrals'
    | '/settings'
    | '/upcoming'
    | '/chat/$mentorshipId'
    | '/ava/$chatId'
    | '/calls/$roomId'
    | '/campaign-codes/$codeId'
    | '/knowledge-base/$triggerKnowledgeBaseId'
    | '/knowledge-base/new'
    | '/mentor-monthly-updates/$mentorshipId'
    | '/mentor-scoring/$mentorId'
    | '/mentors/schedules'
    | '/mentorships/$mentorshipId'
    | '/roles/$roleId'
    | '/users/$userId'
    | '/ava'
    | '/campaign-codes'
    | '/changelog'
    | '/conversations'
    | '/escalations'
    | '/knowledge-base'
    | '/mentor-forecasting'
    | '/mentor-payout'
    | '/mentor-scoring'
    | '/mentors'
    | '/new-teens'
    | '/onboarding'
    | '/risk-flagging'
    | '/roles'
    | '/sms-lifecycle'
    | '/users'
    | '/word-cloud'
    | '/mentor-scoring/details/$snapshotId'
  id:
    | '__root__'
    | '/_admin_chat'
    | '/_auth'
    | '/_authenticated'
    | '/_auth/login'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_authenticated/ava'
    | '/_authenticated/exports'
    | '/_authenticated/mentor-data-dashboard'
    | '/_authenticated/referrals'
    | '/_authenticated/settings'
    | '/_authenticated/upcoming'
    | '/_authenticated/'
    | '/_admin_chat/chat/$mentorshipId'
    | '/_authenticated/ava/$chatId'
    | '/_authenticated/calls/$roomId'
    | '/_authenticated/campaign-codes/$codeId'
    | '/_authenticated/knowledge-base/$triggerKnowledgeBaseId'
    | '/_authenticated/knowledge-base/new'
    | '/_authenticated/mentor-monthly-updates/$mentorshipId'
    | '/_authenticated/mentor-scoring/$mentorId'
    | '/_authenticated/mentors/schedules'
    | '/_authenticated/mentorships/$mentorshipId'
    | '/_authenticated/roles/$roleId'
    | '/_authenticated/users/$userId'
    | '/_authenticated/ava/'
    | '/_authenticated/campaign-codes/'
    | '/_authenticated/changelog/'
    | '/_authenticated/conversations/'
    | '/_authenticated/escalations/'
    | '/_authenticated/knowledge-base/'
    | '/_authenticated/mentor-forecasting/'
    | '/_authenticated/mentor-payout/'
    | '/_authenticated/mentor-scoring/'
    | '/_authenticated/mentors/'
    | '/_authenticated/new-teens/'
    | '/_authenticated/onboarding/'
    | '/_authenticated/risk-flagging/'
    | '/_authenticated/roles/'
    | '/_authenticated/sms-lifecycle/'
    | '/_authenticated/users/'
    | '/_authenticated/word-cloud/'
    | '/_authenticated/mentor-scoring/details/$snapshotId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  Admin_chatRoute: typeof Admin_chatRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin_chat': {
      id: '/_admin_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof Admin_chatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upcoming': {
      id: '/_authenticated/upcoming'
      path: '/upcoming'
      fullPath: '/upcoming'
      preLoaderRoute: typeof AuthenticatedUpcomingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/referrals': {
      id: '/_authenticated/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedReferralsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-data-dashboard': {
      id: '/_authenticated/mentor-data-dashboard'
      path: '/mentor-data-dashboard'
      fullPath: '/mentor-data-dashboard'
      preLoaderRoute: typeof AuthenticatedMentorDataDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/exports': {
      id: '/_authenticated/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AuthenticatedExportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ava': {
      id: '/_authenticated/ava'
      path: '/ava'
      fullPath: '/ava'
      preLoaderRoute: typeof AuthenticatedAvaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/word-cloud/': {
      id: '/_authenticated/word-cloud/'
      path: '/word-cloud'
      fullPath: '/word-cloud/'
      preLoaderRoute: typeof AuthenticatedWordCloudIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sms-lifecycle/': {
      id: '/_authenticated/sms-lifecycle/'
      path: '/sms-lifecycle'
      fullPath: '/sms-lifecycle/'
      preLoaderRoute: typeof AuthenticatedSmsLifecycleIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/': {
      id: '/_authenticated/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AuthenticatedRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/risk-flagging/': {
      id: '/_authenticated/risk-flagging/'
      path: '/risk-flagging'
      fullPath: '/risk-flagging/'
      preLoaderRoute: typeof AuthenticatedRiskFlaggingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/new-teens/': {
      id: '/_authenticated/new-teens/'
      path: '/new-teens'
      fullPath: '/new-teens/'
      preLoaderRoute: typeof AuthenticatedNewTeensIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentors/': {
      id: '/_authenticated/mentors/'
      path: '/mentors'
      fullPath: '/mentors/'
      preLoaderRoute: typeof AuthenticatedMentorsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-scoring/': {
      id: '/_authenticated/mentor-scoring/'
      path: '/mentor-scoring'
      fullPath: '/mentor-scoring/'
      preLoaderRoute: typeof AuthenticatedMentorScoringIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-payout/': {
      id: '/_authenticated/mentor-payout/'
      path: '/mentor-payout'
      fullPath: '/mentor-payout/'
      preLoaderRoute: typeof AuthenticatedMentorPayoutIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-forecasting/': {
      id: '/_authenticated/mentor-forecasting/'
      path: '/mentor-forecasting'
      fullPath: '/mentor-forecasting/'
      preLoaderRoute: typeof AuthenticatedMentorForecastingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/': {
      id: '/_authenticated/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/knowledge-base/'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/escalations/': {
      id: '/_authenticated/escalations/'
      path: '/escalations'
      fullPath: '/escalations/'
      preLoaderRoute: typeof AuthenticatedEscalationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/conversations/': {
      id: '/_authenticated/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AuthenticatedConversationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/changelog/': {
      id: '/_authenticated/changelog/'
      path: '/changelog'
      fullPath: '/changelog/'
      preLoaderRoute: typeof AuthenticatedChangelogIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign-codes/': {
      id: '/_authenticated/campaign-codes/'
      path: '/campaign-codes'
      fullPath: '/campaign-codes/'
      preLoaderRoute: typeof AuthenticatedCampaignCodesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ava/': {
      id: '/_authenticated/ava/'
      path: '/'
      fullPath: '/ava/'
      preLoaderRoute: typeof AuthenticatedAvaIndexRouteImport
      parentRoute: typeof AuthenticatedAvaRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/roles/$roleId': {
      id: '/_authenticated/roles/$roleId'
      path: '/roles/$roleId'
      fullPath: '/roles/$roleId'
      preLoaderRoute: typeof AuthenticatedRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentorships/$mentorshipId': {
      id: '/_authenticated/mentorships/$mentorshipId'
      path: '/mentorships/$mentorshipId'
      fullPath: '/mentorships/$mentorshipId'
      preLoaderRoute: typeof AuthenticatedMentorshipsMentorshipIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentors/schedules': {
      id: '/_authenticated/mentors/schedules'
      path: '/mentors/schedules'
      fullPath: '/mentors/schedules'
      preLoaderRoute: typeof AuthenticatedMentorsSchedulesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-scoring/$mentorId': {
      id: '/_authenticated/mentor-scoring/$mentorId'
      path: '/mentor-scoring/$mentorId'
      fullPath: '/mentor-scoring/$mentorId'
      preLoaderRoute: typeof AuthenticatedMentorScoringMentorIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mentor-monthly-updates/$mentorshipId': {
      id: '/_authenticated/mentor-monthly-updates/$mentorshipId'
      path: '/mentor-monthly-updates/$mentorshipId'
      fullPath: '/mentor-monthly-updates/$mentorshipId'
      preLoaderRoute: typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/new': {
      id: '/_authenticated/knowledge-base/new'
      path: '/knowledge-base/new'
      fullPath: '/knowledge-base/new'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/$triggerKnowledgeBaseId': {
      id: '/_authenticated/knowledge-base/$triggerKnowledgeBaseId'
      path: '/knowledge-base/$triggerKnowledgeBaseId'
      fullPath: '/knowledge-base/$triggerKnowledgeBaseId'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaign-codes/$codeId': {
      id: '/_authenticated/campaign-codes/$codeId'
      path: '/campaign-codes/$codeId'
      fullPath: '/campaign-codes/$codeId'
      preLoaderRoute: typeof AuthenticatedCampaignCodesCodeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calls/$roomId': {
      id: '/_authenticated/calls/$roomId'
      path: '/calls/$roomId'
      fullPath: '/calls/$roomId'
      preLoaderRoute: typeof AuthenticatedCallsRoomIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ava/$chatId': {
      id: '/_authenticated/ava/$chatId'
      path: '/$chatId'
      fullPath: '/ava/$chatId'
      preLoaderRoute: typeof AuthenticatedAvaChatIdRouteImport
      parentRoute: typeof AuthenticatedAvaRoute
    }
    '/_admin_chat/chat/$mentorshipId': {
      id: '/_admin_chat/chat/$mentorshipId'
      path: '/chat/$mentorshipId'
      fullPath: '/chat/$mentorshipId'
      preLoaderRoute: typeof Admin_chatChatMentorshipIdRouteImport
      parentRoute: typeof Admin_chatRoute
    }
    '/_authenticated/mentor-scoring/details/$snapshotId': {
      id: '/_authenticated/mentor-scoring/details/$snapshotId'
      path: '/mentor-scoring/details/$snapshotId'
      fullPath: '/mentor-scoring/details/$snapshotId'
      preLoaderRoute: typeof AuthenticatedMentorScoringDetailsSnapshotIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface Admin_chatRouteChildren {
  Admin_chatChatMentorshipIdRoute: typeof Admin_chatChatMentorshipIdRoute
}

const Admin_chatRouteChildren: Admin_chatRouteChildren = {
  Admin_chatChatMentorshipIdRoute: Admin_chatChatMentorshipIdRoute,
}

const Admin_chatRouteWithChildren = Admin_chatRoute._addFileChildren(
  Admin_chatRouteChildren,
)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedAvaRouteChildren {
  AuthenticatedAvaChatIdRoute: typeof AuthenticatedAvaChatIdRoute
  AuthenticatedAvaIndexRoute: typeof AuthenticatedAvaIndexRoute
}

const AuthenticatedAvaRouteChildren: AuthenticatedAvaRouteChildren = {
  AuthenticatedAvaChatIdRoute: AuthenticatedAvaChatIdRoute,
  AuthenticatedAvaIndexRoute: AuthenticatedAvaIndexRoute,
}

const AuthenticatedAvaRouteWithChildren =
  AuthenticatedAvaRoute._addFileChildren(AuthenticatedAvaRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAvaRoute: typeof AuthenticatedAvaRouteWithChildren
  AuthenticatedExportsRoute: typeof AuthenticatedExportsRoute
  AuthenticatedMentorDataDashboardRoute: typeof AuthenticatedMentorDataDashboardRoute
  AuthenticatedReferralsRoute: typeof AuthenticatedReferralsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedUpcomingRoute: typeof AuthenticatedUpcomingRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCallsRoomIdRoute: typeof AuthenticatedCallsRoomIdRoute
  AuthenticatedCampaignCodesCodeIdRoute: typeof AuthenticatedCampaignCodesCodeIdRoute
  AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute: typeof AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute
  AuthenticatedKnowledgeBaseNewRoute: typeof AuthenticatedKnowledgeBaseNewRoute
  AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute: typeof AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute
  AuthenticatedMentorScoringMentorIdRoute: typeof AuthenticatedMentorScoringMentorIdRoute
  AuthenticatedMentorsSchedulesRoute: typeof AuthenticatedMentorsSchedulesRoute
  AuthenticatedMentorshipsMentorshipIdRoute: typeof AuthenticatedMentorshipsMentorshipIdRoute
  AuthenticatedRolesRoleIdRoute: typeof AuthenticatedRolesRoleIdRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedCampaignCodesIndexRoute: typeof AuthenticatedCampaignCodesIndexRoute
  AuthenticatedChangelogIndexRoute: typeof AuthenticatedChangelogIndexRoute
  AuthenticatedConversationsIndexRoute: typeof AuthenticatedConversationsIndexRoute
  AuthenticatedEscalationsIndexRoute: typeof AuthenticatedEscalationsIndexRoute
  AuthenticatedKnowledgeBaseIndexRoute: typeof AuthenticatedKnowledgeBaseIndexRoute
  AuthenticatedMentorForecastingIndexRoute: typeof AuthenticatedMentorForecastingIndexRoute
  AuthenticatedMentorPayoutIndexRoute: typeof AuthenticatedMentorPayoutIndexRoute
  AuthenticatedMentorScoringIndexRoute: typeof AuthenticatedMentorScoringIndexRoute
  AuthenticatedMentorsIndexRoute: typeof AuthenticatedMentorsIndexRoute
  AuthenticatedNewTeensIndexRoute: typeof AuthenticatedNewTeensIndexRoute
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute
  AuthenticatedRiskFlaggingIndexRoute: typeof AuthenticatedRiskFlaggingIndexRoute
  AuthenticatedRolesIndexRoute: typeof AuthenticatedRolesIndexRoute
  AuthenticatedSmsLifecycleIndexRoute: typeof AuthenticatedSmsLifecycleIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedWordCloudIndexRoute: typeof AuthenticatedWordCloudIndexRoute
  AuthenticatedMentorScoringDetailsSnapshotIdRoute: typeof AuthenticatedMentorScoringDetailsSnapshotIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAvaRoute: AuthenticatedAvaRouteWithChildren,
  AuthenticatedExportsRoute: AuthenticatedExportsRoute,
  AuthenticatedMentorDataDashboardRoute: AuthenticatedMentorDataDashboardRoute,
  AuthenticatedReferralsRoute: AuthenticatedReferralsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedUpcomingRoute: AuthenticatedUpcomingRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCallsRoomIdRoute: AuthenticatedCallsRoomIdRoute,
  AuthenticatedCampaignCodesCodeIdRoute: AuthenticatedCampaignCodesCodeIdRoute,
  AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute:
    AuthenticatedKnowledgeBaseTriggerKnowledgeBaseIdRoute,
  AuthenticatedKnowledgeBaseNewRoute: AuthenticatedKnowledgeBaseNewRoute,
  AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute:
    AuthenticatedMentorMonthlyUpdatesMentorshipIdRoute,
  AuthenticatedMentorScoringMentorIdRoute:
    AuthenticatedMentorScoringMentorIdRoute,
  AuthenticatedMentorsSchedulesRoute: AuthenticatedMentorsSchedulesRoute,
  AuthenticatedMentorshipsMentorshipIdRoute:
    AuthenticatedMentorshipsMentorshipIdRoute,
  AuthenticatedRolesRoleIdRoute: AuthenticatedRolesRoleIdRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedCampaignCodesIndexRoute: AuthenticatedCampaignCodesIndexRoute,
  AuthenticatedChangelogIndexRoute: AuthenticatedChangelogIndexRoute,
  AuthenticatedConversationsIndexRoute: AuthenticatedConversationsIndexRoute,
  AuthenticatedEscalationsIndexRoute: AuthenticatedEscalationsIndexRoute,
  AuthenticatedKnowledgeBaseIndexRoute: AuthenticatedKnowledgeBaseIndexRoute,
  AuthenticatedMentorForecastingIndexRoute:
    AuthenticatedMentorForecastingIndexRoute,
  AuthenticatedMentorPayoutIndexRoute: AuthenticatedMentorPayoutIndexRoute,
  AuthenticatedMentorScoringIndexRoute: AuthenticatedMentorScoringIndexRoute,
  AuthenticatedMentorsIndexRoute: AuthenticatedMentorsIndexRoute,
  AuthenticatedNewTeensIndexRoute: AuthenticatedNewTeensIndexRoute,
  AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  AuthenticatedRiskFlaggingIndexRoute: AuthenticatedRiskFlaggingIndexRoute,
  AuthenticatedRolesIndexRoute: AuthenticatedRolesIndexRoute,
  AuthenticatedSmsLifecycleIndexRoute: AuthenticatedSmsLifecycleIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedWordCloudIndexRoute: AuthenticatedWordCloudIndexRoute,
  AuthenticatedMentorScoringDetailsSnapshotIdRoute:
    AuthenticatedMentorScoringDetailsSnapshotIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  Admin_chatRoute: Admin_chatRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
